<template>
    <div class="container">
        <div class="map_contact">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3184.9221338098246!2d22.106003783456664!3d37.035502900451554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1361b1d4a18908af%3A0x9c089a6bde99b52b!2zzqTPg861z4TPg861zr3Orc66zr_PhSDOlc-Fz4PPhM6xzrjOr86x!5e0!3m2!1sen!2snl!4v1710769883044!5m2!1sen!2snl" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
</template>
